var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSendingEmptyImg = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 128,
    viewBox: "0 0 107 128",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3131 119.351L0.310547 91.5008L47.8755 64L95.8781 91.8505L48.3131 119.351Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5669 42.2045L71.5814 38.1764L55.6378 28.973L16.2617 51.7024L32.2329 60.9252L39.1897 64.9442L56.5009 74.9371L95.8586 52.2089L95.8781 52.1986L78.5669 42.2045Z",
    fill: "#FFDDA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8412 29.3833L17.4922 51.5853L38.9186 63.9867L46.9416 68.6235L56.7076 74.1162L64.7294 69.6392L95.0566 52.0822L55.8412 29.3833Z",
    fill: "#F9C98A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4803 75.1839V114.335L39.2146 104.44L32.2247 100.439L16.2617 91.2895V51.9551L32.2247 61.1792L39.2146 65.2068L56.4803 75.1839Z",
    fill: "#BC7C46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4805 75.1306V114.335L95.8783 91.7164V52.3654L56.4805 75.1306Z",
    fill: "#DDA866"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6097 82.2451L62.3832 82.3902V78.0223L62.6097 77.8759V82.2451Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5227 78.4486L63.3381 78.7018L62.4974 78.2333L61.6553 79.5174L61.4707 79.4407L62.4974 77.8759L63.5227 78.4486Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6599 81.0127L64.4346 81.1591V76.7912L64.6599 76.6448V81.0127Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5735 77.2168L65.3888 77.4724L64.5488 77.0024L63.7062 78.2864L63.5215 78.2107L64.5488 76.6448L65.5735 77.2168Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8624 80.6166L61.1848 83.211L61.0605 83.1414L61.1848 82.934L65.8624 80.3383L65.9853 80.4092L65.8624 80.6166Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0882 77.5433C60.7547 77.738 60.482 78.2035 60.4807 78.5875V83.6994C60.4807 84.0834 60.7547 84.2412 61.0895 84.0479L65.5446 81.4939C65.8795 81.2993 66.1508 80.8324 66.1508 80.4471L66.1522 75.3366C66.1508 74.9512 65.8795 74.7947 65.5446 74.9867L61.0882 77.5433ZM65.5445 81.7701L61.0893 84.3267C60.6195 84.5963 60.2383 84.378 60.2383 83.8388V78.7282C60.2383 78.189 60.6195 77.5341 61.0893 77.2645L65.5445 74.7066C66.0117 74.4396 66.3942 74.658 66.3942 75.1971V80.3103C66.3942 80.8456 66.0117 81.5031 65.5445 81.7701Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2927 78.2863L70.1794 78.2209V74.7889L70.2927 74.5928L70.406 74.6582L70.4072 78.0926L70.2927 78.2863Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0644 73.8515C67.7295 74.0409 67.4569 74.5117 67.4556 74.8944V80.0063C67.4556 80.3917 67.7295 80.5469 68.0657 80.3549L72.5195 77.7996C72.8544 77.6075 73.1257 77.1394 73.1257 76.7553L73.127 71.6408C73.1257 71.2568 72.8544 71.1029 72.5195 71.2936L68.0644 73.8515ZM72.5197 78.0784L68.0659 80.6337C67.5947 80.9033 67.2148 80.6823 67.2148 80.1471V75.0365C67.2148 74.4959 67.5947 73.8397 68.0659 73.5701L72.5197 71.0135C72.9882 70.7452 73.3707 70.9661 73.3707 71.504V76.6146C73.3707 77.1538 72.9882 77.8101 72.5197 78.0784Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1408 74.4231C71.9667 73.7103 71.2078 73.5525 70.2947 74.1006C69.3816 74.6501 68.6227 75.7215 68.4473 76.6447L72.1408 74.4231Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4724 74.114L69.3604 74.05V73.214L69.4724 73.0195L69.5857 73.0835V73.9195L69.4724 74.114Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2939 74.1146L70.1807 74.0494V73.2134L70.2939 73.0189L70.406 73.0841V73.9201L70.2939 74.1146Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7023 73.2932L70.5914 73.2304V72.3945L70.7023 72.1987L70.8155 72.2627V73.0987L70.7023 73.2932Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6344 69.7454C74.2983 69.9375 74.027 70.4057 74.027 70.7898V75.9038C74.027 76.2865 74.2983 76.4431 74.6344 76.2524L79.0886 73.6954C79.422 73.5033 79.6946 73.0351 79.6933 72.6497L79.6946 67.5357C79.6946 67.1529 79.422 66.9951 79.0886 67.1884L74.6344 69.7454ZM79.0903 73.9729L74.6348 76.5286C74.1637 76.7995 73.7812 76.5799 73.7826 76.0419L73.7812 70.9279C73.7812 70.3913 74.1637 69.7349 74.6348 69.4653L79.0889 66.9109C79.5561 66.6413 79.9372 66.8596 79.9372 67.3963V72.5103C79.9372 73.0469 79.5561 73.7033 79.0903 73.9729Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2705 73.772L77.156 73.7055V70.2757L77.2705 70.0785L77.3825 70.1451L77.3838 73.576L77.2705 73.772Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3923 74.4037L76.2441 74.3397L76.3923 74.144L78.1495 73.1401L78.2961 73.2042L78.1495 73.3999L76.3923 74.4037Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2963 68.8472V70.6139C78.2977 71.0923 77.9521 71.6726 77.5329 71.9104L76.5974 72.4377C76.1754 72.6782 75.834 72.4825 75.834 72.0069V70.2402L76.2962 69.9779V71.8696L76.4239 71.943L76.5516 71.7256V69.8338L78.2963 68.8472Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2443 104.485L32.2676 100.461V60.9405L39.2443 57.3121V104.485Z",
    fill: "#9B7451"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2672 65.0602L39.2305 65.0876L32.2676 61.0825V61.0448L71.6505 38.412L78.6421 42.4262L39.2672 65.0602Z",
    fill: "#CAAF8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7429 109.549L84.5437 98.1621L94.1483 104.505L74.3475 115.892C67.1134 119.645 61.2287 112.173 64.7429 109.549Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9519 104.768C85.9025 106.915 90.6786 106.915 93.6505 104.768C95.1364 103.695 95.8793 102.46 95.8793 101.521V99.4814V97.7659H80.7654V100.796C80.723 102.246 81.4447 103.668 82.9519 104.768Z",
    fill: "url(#paint0_linear_1328_52692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9518 103.903C85.9024 106.05 90.6786 106.05 93.6504 103.903C95.1363 102.83 95.8793 101.407 95.8793 99.9852L95.8368 50.1621H80.7441L80.7654 99.9315C80.7229 101.381 81.4446 102.803 82.9518 103.903Z",
    fill: "url(#paint1_linear_1328_52692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9776 53.2775C85.932 54.8895 90.7143 54.8895 93.69 53.2775C95.1779 52.4716 95.8793 51.4238 95.8793 50.3559V50.1947V48.8649L80.7458 48.9253V50.2955C80.7033 51.3835 81.4685 52.4514 82.9776 53.2775Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6375 52.29C90.6663 54.0544 85.891 54.0765 82.941 52.29C81.2007 51.2535 80.5003 49.8199 80.8187 48.4525C80.8823 48.232 80.946 48.0114 81.0521 47.8129C81.3917 47.1072 82.0496 46.4455 82.9834 45.8721C85.9547 44.1077 90.7299 44.0857 93.68 45.8721C96.63 47.6365 96.6088 50.5257 93.6375 52.29Z",
    fill: "#FFDDA8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.3116,
    cy: 48.8649,
    rx: 7.56757,
    ry: 4.32432,
    transform: "rotate(-0.258255 88.3116 48.8649)",
    fill: "#EABB7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1328_52692",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38C4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1328_52692",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA866"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendingEmptyImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sendingEmptyImg.9e9c68d7.svg";
export { ForwardRef as ReactComponent };